import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const Nav = ({value, handleChange, changeable, ...rest}) => {
    return <AppBar style={{backgroundColor: "#fff"}}  {...rest} position="static">
    <Tabs indicatorColor="primary" value={value} onChange={(event, newValue) => handleChange(newValue)}
          variant="scrollable"
          style={{color: "#000"}}
          scrollButtons="auto">
      <Tab label="Start" />
      <Tab disabled={!changeable} label="Adress" />
      <Tab disabled={!changeable} label="Mått"  />
      <Tab disabled={!changeable} label="Taklutning"  />
      <Tab disabled={!changeable} label="Tak"  />
      <Tab disabled={!changeable} label="Panelpaket"  />
      <Tab disabled={!changeable} label="Sammanfattning"  />
      <Tab disabled={!changeable} backgroundColor="primary" color="primary" label="Avancerad" style={{marginLeft: "auto"}} />
    </Tabs>
  </AppBar>

};

export default Nav;